import { ApiClientSerializer } from './serializers/apiClients';
import { apiFetch } from './utils/api';

const url = '/v4/api-clients';

export const apiClients = {
  get: async () => {
    const { body } = await apiFetch(url, { method: 'GET' });
    return body;
  },

  create: async (data) => {
    const { body } = await apiFetch(url, {
      method: 'POST',
      body: ApiClientSerializer.serialize(data),
    });
    return body;
  },

  update: async (data) => {
    const { body } = await apiFetch(`${url}/${data.id}`, {
      method: 'PATCH',
      body: ApiClientSerializer.serialize(data),
    });
    return body;
  },

  destroy: async (id) => {
    const { body } = await apiFetch(`${url}/${id}`, { method: 'DELETE' });
    return body;
  },

  rotateSecret: async (id) => {
    const { body } = await apiFetch(`${url}/${id}/rotate-secret`, {
      method: 'POST',
    });
    return body;
  },
};
